export const demoHero = {
  eyebrow: '项目演示中心',
  title: '九畴云市',
  titleHighlight: '数字经济操作系统 · 数字孪生演示',
  subtitle: '不只是看文字，而是进入数字孪生演示界面，直接体验每一个角色视角。',
  desc: '从 0# 帝星咖啡到 1# 大庄科，再到县域数字商业网络与千县万村，投资人可以切换消费者、云店长、云社员、供应链、AI 智能体、数字货架与数据看板等视角，直观理解九畴云市如何运转。',
};

export const demoSystemModules = [
  { key: 'AI', icon: 'ri-robot-2-line' },
  { key: '数字货架', icon: 'ri-store-2-line' },
  { key: 'ePin', icon: 'ri-qr-code-line' },
  { key: '数字消费', icon: 'ri-red-packet-line' },
  { key: '数据中台', icon: 'ri-database-2-line' },
  { key: '智能清分', icon: 'ri-flow-chart' },
];

export const demoRoles = [
  { key: '消费者', icon: 'ri-user-line' },
  { key: '云店长', icon: 'ri-store-2-line' },
  { key: '云社员', icon: 'ri-team-line' },
  { key: '供应链', icon: 'ri-truck-line' },
  { key: 'AI 智能体', icon: 'ri-robot-2-line' },
  { key: '数字货架', icon: 'ri-layout-grid-line' },
  { key: '数据看板', icon: 'ri-dashboard-3-line' },
];

export const demoPanels: Record<
  string,
  { title: string; desc: string; stats: string[]; detail: string }
> = {
  消费者: {
    title: '消费者视角',
    desc: '通过 TOMA 智能体获得美食社交、健康管家与数字服务，享受红包、权益与核销体验。',
    stats: ['红包到账 3 秒', '数字消费权益', 'ePin 一物一码'],
    detail: '消费者扫码进入云铺，TOMA 智能体推荐商品与健康服务，红包实时到账，核销即完成交易，消费数据沉淀为运营资产。',
  },
  云店长: {
    title: '云店长视角',
    desc: '使用数字货架完成商品数字化上架，通过信用进货机制获得小额授信与季度扎账。',
    stats: ['数字货架', '信用进货', '季度扎账'],
    detail: '云店长将门店商品上架数字货架，获得信用进货额度，按季度扎账结算，告别传统进货的资金压力。',
  },
  云社员: {
    title: '云社员视角',
    desc: '作为分布式经营节点，连接城乡消费场景，参与协同与服务。',
    stats: ['云社员协同', '城乡消费', '分布式节点'],
    detail: '云社员是九畴云市的分布式经营节点，连接城乡消费场景，参与协同服务并分享数字化收益。',
  },
  供应链: {
    title: '供应链视角',
    desc: '通过 ePin 溯源与品质认证，实现农产品数字化上行与供应链连接。',
    stats: ['ePin 溯源', '品质认证', '农产品上行'],
    detail: '供应链企业为农产品赋予 ePin 数字身份，完成品质认证与溯源存证，实现农产品从田间到餐桌的数字化上行。',
  },
  'AI 智能体': {
    title: 'AI 智能体（TOMA）',
    desc: '掌中智能体作为 AI 交互入口，承载美食社交、健康管家与数字服务。',
    stats: ['TOMA', '健康管家', '数字服务'],
    detail: 'TOMA 作为掌中智能体，是九畴云市的 AI 交互入口，承载美食社交、健康管家与数字服务，让县域用户拥有懂自己的 AI 助手。',
  },
  数字货架: {
    title: '数字货架',
    desc: '商品数字化展示、交易入口与数据回流的统一载体。',
    stats: ['产品展示', '交易入口', '数据回流'],
    detail: '数字货架把分散的县域商品组织成集中的展示与交易入口，每一次点击与交易都沉淀为可运营的数据。',
  },
  数据看板: {
    title: '数据看板',
    desc: '交易记录、数据看板、智能合约与多方协同的实时数据视图。',
    stats: ['交易记录', '智能合约', '多方协同'],
    detail: '数据看板实时呈现交易记录与多方协同数据，让运营者直观掌握县域商业网络的运转状态。',
  },
};

export const twinFlow = [
  { label: '0# 帝星咖啡', sub: '城市验证 · 运行中', active: true },
  { label: '1# 大庄科', sub: '乡村复制 · 规划中', active: false },
  { label: '县域数字商业网络', sub: '规模化复制 · 规划中', active: false },
  { label: '千县万村', sub: '远期目标', active: false },
];

export const twinStats = [
  { k: '会员', v: '40,000' },
  { k: '商品', v: '10–20' },
  { k: '消费卡', v: '1,000' },
  { k: '云铺激活', v: '动态' },
];